import { render, staticRenderFns } from "./Explanation.vue?vue&type=template&id=12d88f4d&scoped=true&"
import script from "./Explanation.vue?vue&type=script&lang=js&"
export * from "./Explanation.vue?vue&type=script&lang=js&"
import style0 from "./Explanation.vue?vue&type=style&index=0&id=12d88f4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d88f4d",
  null
  
)

export default component.exports